// src/App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import ProductPage from './components/ProductPage';
import TeamPage from './components/Teampage';
import AboutUsPage from './components/AboutUsPage';
import StructuredData from './components/StructuredData';

function App() {
  return (
    <ThemeProvider>
      <HelmetProvider>
        <StructuredData />
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/about" element={<AboutUsPage />} />
              {/* Make the "/contact" route also render the TeamPage */}
              <Route path="/contact" element={<TeamPage />} />
            </Routes>
          </main>
          <div className="container">
            <Footer />
          </div>
        </BrowserRouter>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;